import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { MENU_CONFIG } from './Sidebar';

export default function MenuLabelsBeheer() {
  const [afdelingen, setAfdelingen] = useState([]);
  const [selId, setSelId] = useState(null);
  const [labels, setLabels] = useState({});
  const [msg, setMsg] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get('/sidebar/labels/beheer')
      .then(r => {
        const afd = r.data.afdelingen || [];
        setAfdelingen(afd);
        if (afd.length) { setSelId(afd[0].id); setLabels(afd[0].menu_labels || {}); }
      })
      .catch(() => setAfdelingen([]));
  }, []);

  const kies = (id) => {
    const nid = parseInt(id);
    setSelId(nid);
    const afd = afdelingen.find(a => a.id === nid);
    setLabels(afd?.menu_labels || {});
    setMsg(null);
  };

  const zet = (key, veld, waarde) => {
    setLabels(prev => {
      const cur = { ...(prev[key] || {}) };
      if (waarde) cur[veld] = waarde; else delete cur[veld];
      const next = { ...prev };
      if (Object.keys(cur).length) next[key] = cur; else delete next[key];
      return next;
    });
  };

  const opslaan = async () => {
    setSaving(true); setMsg(null);
    try {
      const r = await api.put(`/sidebar/labels/${selId}`, { labels });
      setLabels(r.data.labels || {});
      setAfdelingen(prev => prev.map(a => a.id === selId ? { ...a, menu_labels: r.data.labels } : a));
      setMsg({ ok: true, t: 'Opgeslagen ✓ — zichtbaar na herladen (F5)' });
    } catch (e) {
      setMsg({ ok: false, t: e.response?.data?.message || 'Opslaan mislukt' });
    }
    setSaving(false);
  };

  if (!afdelingen.length) return null;

  return (
    <div className="settings-card full-width" style={{ marginTop: 16 }}>
      <h2>📋 Menu-teksten per afdeling</h2>
      <p className="card-description">
        Geef menu-items een eigen naam en icoon voor deze afdeling. Leeg = standaard.
      </p>
      {afdelingen.length > 1 && (
        <select value={selId || ''} onChange={e => kies(e.target.value)}
          style={{ padding: '6px 10px', borderRadius: 6, border: '1px solid #d1d5db', marginBottom: 12 }}>
          {afdelingen.map(a => <option key={a.id} value={a.id}>{a.naam}</option>)}
        </select>
      )}
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
        <thead>
          <tr style={{ textAlign: 'left', color: '#6b7280', fontSize: 11, textTransform: 'uppercase' }}>
            <th style={{ padding: '6px 8px' }}>Standaard</th>
            <th style={{ padding: '6px 8px', width: 70 }}>Icoon</th>
            <th style={{ padding: '6px 8px' }}>Eigen naam</th>
          </tr>
        </thead>
        <tbody>
          {MENU_CONFIG.map(item => (
            <tr key={item.key} style={{ borderTop: '1px solid #f3f4f6' }}>
              <td style={{ padding: '6px 8px', whiteSpace: 'nowrap' }}>{item.icon} {item.label}</td>
              <td style={{ padding: '6px 8px' }}>
                <input value={labels[item.key]?.icon || ''} placeholder={item.icon}
                  maxLength={4}
                  onChange={e => zet(item.key, 'icon', e.target.value)}
                  style={{ width: 50, padding: '4px 6px', borderRadius: 6, border: '1px solid #d1d5db', textAlign: 'center' }} />
              </td>
              <td style={{ padding: '6px 8px' }}>
                <input value={labels[item.key]?.label || ''} placeholder={item.label}
                  maxLength={40}
                  onChange={e => zet(item.key, 'label', e.target.value)}
                  style={{ width: '100%', maxWidth: 260, padding: '4px 8px', borderRadius: 6, border: '1px solid #d1d5db' }} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 12 }}>
        <button className="btn-primary" onClick={opslaan} disabled={saving}>
          {saving ? '…' : 'Opslaan'}
        </button>
        {msg && <span style={{ fontSize: 12, color: msg.ok ? '#16a34a' : '#dc2626' }}>{msg.t}</span>}
      </div>
    </div>
  );
}
